"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueAlertProvider = exports.IssueAlertContext = exports.AlertProvider = exports.useAlerts = void 0;
const React = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const notistack_1 = require("notistack");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const sp10_1 = require("../../themes/sp10/sp10");
const useLanguage_1 = require("../../languages/useLanguage");
const styled_components_1 = __importStar(require("styled-components"));
exports.useAlerts = function () {
    const { enqueueSnackbar, closeSnackbar } = notistack_1.useSnackbar();
    const dismiss = (key) => closeSnackbar(key);
    const UnstyledButton = (props) => React.createElement(core_1.Button, Object.assign({}, props));
    const AlertMessageWithHeader = (props) => (React.createElement(React.Fragment, null,
        props.header ? (React.createElement("span", { className: "alert header" }, props.header)) : null,
        React.createElement("span", { className: "alert message" }, props.message)));
    const languageId = useLanguage_1.useLanguage();
    return {
        issueAlert: (options) => {
            let { actions, type, message, header, ...snackOptions } = LocalizedComponent_1.getLocalizedProps(options, languageId, undefined, options.localize, options.variables);
            actions = actions || { OK: key => dismiss(key) };
            type = type || "default";
            const StyledButton = styled_components_1.default(UnstyledButton) `
            && {
               &:hover {
                  background: transparent;
               }
               & span {
                  color: ${props => type === "default"
                ? props.theme["action-button-hover-text-color"]
                : props.theme["input-color"]};
                  display: contents;
               }
               &:hover span {
                  color: ${props => props.theme["hover-color"]};
               }
               &:active span {
                  color: ${props => props.theme["active-color"]};
               }
            }
         `;
            const key = enqueueSnackbar(React.createElement(styled_components_1.ThemeProvider, { theme: sp10_1.sp10 },
                React.createElement(AlertMessageWithHeader, { header: header, message: message })), {
                ...snackOptions,
                autoHideDuration: options.autoHideDuration || 5000,
                variant: type,
                action: key => actions &&
                    Object.keys(actions).map((actionName, index) => (React.createElement(StyledButton, { key: index, onClick: () => actions && actions[actionName]
                            ? actions[actionName](key)
                            : dismiss(key) },
                        React.createElement("span", null, actionName)))),
                anchorOrigin: { vertical: "top", horizontal: "center" }
            });
            return key;
        },
        dismissAlert: closeSnackbar
    };
};
exports.AlertProvider = (props) => {
    const { maxAlerts, ...snackbarProviderProps } = props;
    return (React.createElement(notistack_1.SnackbarProvider, Object.assign({ maxSnack: maxAlerts, dense: true, classes: {
            variantSuccess: "alert success",
            variantError: "alert error",
            variantInfo: "alert info",
            variantWarning: "alert warning",
            containerAnchorOriginTopCenter: "z-alert"
        }, preventDuplicate: true }, snackbarProviderProps)));
};
exports.IssueAlertContext = React.createContext(null);
exports.IssueAlertProvider = (props) => {
    const { issueAlert } = exports.useAlerts();
    return (React.createElement(exports.IssueAlertContext.Provider, { value: issueAlert }, props.children));
};
//# sourceMappingURL=ZAlert.js.map